<script lang="ts" setup>
import {useAccount} from "@/scripts/store/account";
import {computed} from "vue";
import {storeToRefs} from "pinia";

const accountStore = useAccount()
const {account} = storeToRefs(accountStore);

const hasScansLimitReached = computed(() => {
    return account.value.currentPlan.scansLimit != 0
        && account.value.currentPlan.scansLimit <= account.value.statistics.scansCount
})

const hasCodesLimitReached = computed(() => {
    return  account.value.currentPlan.qrCodesLimit != 0
        && account.value.currentPlan.qrCodesLimit <= account.value.statistics.qrCodesCount
})

</script>

<template>
    <div class="rounded-md bg-red-50 p-4" v-if="hasScansLimitReached">
        <div class="flex">
            <div class="ml-3">
                <h3 class="text-sm font-medium text-red-800">Исчерпан лимит сканирований для
                    аккаунта</h3>
                <div class="mt-2 text-sm text-red-700">
                    Все активные коды были отключены. Для возобновления работы перейдите на <a href="/billing"
                                                                                               class="border-bottom border-b-2">следующий
                    тарифный план</a> или дождитесь нового месяца.
                </div>
            </div>
        </div>
    </div>

    <div class="rounded-md bg-red-50 p-4" v-if="hasCodesLimitReached">
        <div class="flex">
            <div class="ml-3">
                <h3 class="text-sm font-medium text-red-800">
                    Исчерапно количество кодов в аккаунте
                </h3>
                <div class="mt-2 text-sm text-red-700">
                    Если хотите создать новый код - перейдите на <a href="/billing"
                                                                                               class="border-bottom border-b-2">следующий
                    тарифный план</a> или удалите один из текущих кодов.
                </div>
            </div>
        </div>
    </div>

</template>
